import {
	useState,
	useEffect
} from 'react'
import {
	useDispatch,
	useSelector
} from 'react-redux'
import {
	envAwarePost
} from '../../../util/util'
import {
	updateMessenger,
	selectShowMessenger,
	selectMessengerClass
} from '../liveClassesSlice'

import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'

import Select from 'react-select'

const mapClientsToOptions = clients => clients?.map(c=>({
	value:c.user_id_number,
	label:c.user_name,
	id:c.user_id_number
}))

const mapTagsToOptions = tags => tags?.map(t=>({
	value:t.id,
	label:t.name,
	id:t.id
}))

const NotifyModal = ()=>{
	const dispatch = useDispatch()
	const show = useSelector(selectShowMessenger)
	const liveClass = useSelector(selectMessengerClass)
	const [participants,setParticipants] = useState([])
	const [status,setStatus] = useState('idle')
	const [specifyByTag,setSpecifyByTag] = useState(false)
	const [sendToAll,setSendToAll] = useState(false)
	const [tagsToSend,setTagsToSend] = useState([])
	const [clientsToSend,setClientsToSend] = useState([])
	const [clients,setClients] = useState([])
	const [tags,setTags] = useState([])
	//generate price string
	let price;
	if(liveClass?.advancedPricing==1){
		const isFree = liveClass?.clientFree == 1;
		price = isFree ? 'Free' : '$'+liveClass?.clientPrice;
	}else{
		const isFree = liveClass?.free == 1;
		price = isFree ? 'Free' : '$'+liveClass?.price;
	}
	const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone
	
	//calculate spots left
	const spotsLeft = parseInt(liveClass?.max_size) - parseInt(liveClass?.class_size)
	//construct default msg string
	const defaultMsg = [
		`New Live Class!\n`,
		`- ${liveClass?.title} -`,
		liveClass?.description+'\n',
		'- Info -',
		// commented out until dynamic message TZ
		// solution is developed
		`When: ${liveClass?.startDatePretty} (${TZ})`,
		`length: ${liveClass?.duration}mins`,
		`Price: ${price}`,
		`Spots left: ${spotsLeft}\n`,
		'Note: For more info or to access classes please log into your account on www.fitsw.com (ie on the website)'
	].join('\n')
	const [message,setMessage] = useState(defaultMsg)
	useEffect(() => {
		envAwarePost(
			'api/users/api/',
			{action:'getAllClients'}
		).then(res=>{
			setClients(res.data)
		})
		envAwarePost(
			'api/users/api/',
			{action:'getAllTags'}
		).then(res=>{
			setTags(res.data)
		})
	},[show])
	useEffect(()=>{
		setMessage(defaultMsg)
	},[liveClass])
	const clientsOptions = mapClientsToOptions(clients)
	const tagsOptions = mapTagsToOptions(tags)
	const onHide = ()=>{
		dispatch(updateMessenger({
			show:false,
			id:null
		}))
	}
	if(!liveClass) return null

	const handleSend = ()=>{
		setStatus('pending')
		const postData = { message }

		if(sendToAll&&!specifyByTag){
			postData.action = 'sendToAll'
			postData.send_to_all = 1
		}else{
			postData.action = 'sendToSpecified'
			if(specifyByTag){
				postData.specify_by_tag = 1
				postData.tag_ids = tagsToSend.map(t=>t.value)
			}else{
				postData.recipients = clientsToSend.map(c=>c.value)
			}
			
		}
		envAwarePost('api/messaging/api/',postData).then(res=>{
			setStatus('idle')
			setMessage('')
			setTagsToSend([])
			setClientsToSend([])
			setSendToAll(false)
			onHide()
		})
	}

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				Notify Clients
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex justify-content-between mb-2">
					<small>Search clients/tags or select all</small>
					<div className="d-flex align-items-center" style={{fontSize:'14px'}}>
						<span className="mr-2">specify recipients by:</span>
						<label className="m-0 mr-2">
							<input 
								name="create_specification" 
								type="radio"
								onChange={()=>setSpecifyByTag(false)}
								checked={!specifyByTag}
							/> Name
						</label>
						<label className="m-0">
							<input 
								name="create_specification" 
								type="radio"
								onChange={()=>setSpecifyByTag(true)}
								checked={specifyByTag}
							/> Tag
						</label>
					</div>
				</div>
				<div className="d-flex">
					<div style={{flex:'1 1 auto'}}>
						<Select
							isDisabled={sendToAll&&!specifyByTag}
							value={specifyByTag ? tagsToSend : clientsToSend}
							isMulti={true}
							onChange={(value)=>{
								if(specifyByTag) setTagsToSend(value)
								else setClientsToSend(value)
							}}
							options={specifyByTag?tagsOptions:clientsOptions}
						/>
					</div>
					{!specifyByTag &&
						<Button 
							onClick={ () => setSendToAll(!sendToAll) }
							variant={ sendToAll ? 'success' : 'outline-success' }
							className="ml-1"
						>
							All
						</Button>
					}
				</div>
				<Form.Control 
					onChange={e=>{setMessage(e.target.value)}}
					style={{height:'332px'}}
					className="mt-1"
					value={message}
					as="textarea" 
				/>
				<div className="d-flex justify-content-end mt-1">
					<Button 
						disabled={
							status==='pending' ||
							(specifyByTag&&!tagsToSend.length) ||
							(!sendToAll&&!clientsToSend.length)
						}
						variant="outline-primary" 
						onClick={handleSend} 
						size="sm"
					>
						Send {status==='pending'&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default NotifyModal